import React, { Component } from "react";
import { Row, Col, Button } from "react-bootstrap";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import { scopeBranches, onBranchScopeChange } from "../../../../utils/branchScope";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import CardLessDataTable from "../../datatables/CardLessDataTableWithSearch";
import FeeStatusModal from './FeeModal';
import FeeReportDateWise from './FeeReportDateWise'
import { attachModuleGuard, AccessDeniedModal } from "../../../../utils/moduleGuard";

// /Fee-Structure/* → "Fee_Structure". Match on module_key only.
// This tab holds no mutations itself — it OPENS FeeStatusModal, which is where payments,
// concessions/discounts and term changes are saved. Gating the opener is what stops those
// writes: the modal is unreachable any other way. The read-only report modal stays open.
const FEE_STRUCTURE_MODULE = ["Fee_Structure"];

const GET_ACADEMIC_YEARS = gql`
    query getAcademicYears($id: Int) {
      getAcademicYears(id: $id) {
        id
        academic_year
      }
    }
  `;

const GET_CLASSES = gql`
      query($id: Int) {
          getExamClasses(id: $id) {
              id
              class
          }
      }
  `;

const GET_BRANCHES = gql`
      query getBranches($institution_id: Int!) {
          getBranches(institution_id: $institution_id) {
              id
              branch_name
              sections {
                  id
                  class_id
                  stream_id
                  section_name
              }
          }
      }
  `;

const GET_STREAMS = gql`
      query {
          getStreams {
              id
              stream
          }
      }
  `;

// Stream applies to Class 11/12 only. This used to be a hardcoded id list —
// `STREAM_CLASS_IDS = [15, 16]` — which is wrong for this data: id 15 is Nursery and
// id 16 a disabled "Class 12" duplicate, while the real streamed classes are ids 1/2.
// Nursery was therefore treated as streamed, and since its sections carry stream_id
// NULL, the stream test below matched nothing and emptied the Section dropdown.
// Decide from the section data instead: a class is streamed only when its own sections
// actually carry a stream_id. Nursery/LKG/UKG/Class 1-10 -> all NULL -> not streamed.

// ── Checkbox Dropdown ────────────────────────────────────────────────────────
class CheckboxDropdown extends React.Component {
    constructor(props) {
        super(props);
        this.state = { open: false };
        this.ref = React.createRef();
    }
    componentDidMount() { document.addEventListener("mousedown", this.handleOutside); }
    componentWillUnmount() { document.removeEventListener("mousedown", this.handleOutside); }
    handleOutside = (e) => {
        if (this.ref.current && !this.ref.current.contains(e.target)) this.setState({ open: false });
    };
    toggle = (id) => {
        const { value, onChange } = this.props;
        onChange(value.includes(id) ? value.filter(v => v !== id) : [...value, id]);
    };
    render() {
        const { options, value, placeholder, onChange } = this.props;
        const { open } = this.state;
        const label = value.length === 0 ? placeholder
            : value.length === options.length ? `All (${options.length})`
                : value.length === 1 ? (options.find(o => o.value === value[0])?.label || `${value.length} selected`)
                    : `${value.length} selected`;
        return (
            <div ref={this.ref} style={{ position: "relative" }}>
                <div onClick={() => this.setState({ open: !open })}
                    style={{ borderRadius: 10, border: "1.5px solid #e5e7eb", padding: "9px 14px", fontSize: 14, color: value.length ? "#1f2937" : "#9ca3af", background: "#f9fafb", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", userSelect: "none" }}>
                    <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{label}</span>
                    <i className={`fal fa-chevron-${open ? "up" : "down"}`} style={{ fontSize: 11, color: "#9ca3af", flexShrink: 0, marginLeft: 6 }} />
                </div>
                {open && (
                    <div style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, background: "#fff", border: "1.5px solid #e5e7eb", borderRadius: 10, boxShadow: "0 8px 24px rgba(0,0,0,0.10)", zIndex: 9999, maxHeight: 220, overflowY: "auto" }}>
                        {options.length === 0 ? (
                            <div style={{ padding: "10px 14px", fontSize: 12, color: "#9ca3af" }}>No options</div>
                        ) : (<>
                            <div onClick={() => onChange(value.length === options.length ? [] : options.map(o => o.value))}
                                style={{ padding: "8px 12px", fontSize: 12, fontWeight: 700, color: "#6366f1", cursor: "pointer", borderBottom: "1px solid #f3f4f6", display: "flex", alignItems: "center", gap: 8 }}>
                                <input type="checkbox" readOnly checked={value.length === options.length} style={{ accentColor: "#6366f1" }} />
                                Select All
                            </div>
                            {options.map(o => (
                                <div key={o.value} onClick={() => this.toggle(o.value)}
                                    style={{ padding: "7px 12px", fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", gap: 8, background: value.includes(o.value) ? "#f5f3ff" : "transparent", borderBottom: "1px solid #f9fafb" }}>
                                    <input type="checkbox" readOnly checked={value.includes(o.value)} style={{ accentColor: "#6366f1" }} />
                                    <span style={{ color: value.includes(o.value) ? "#6d28d9" : "#374151", fontWeight: value.includes(o.value) ? 600 : 400 }}>{o.label}</span>
                                </div>
                            ))}
                        </>)}
                    </div>
                )}
            </div>
        );
    }
}

const GET_STUDENT_FEE_DASHBOARD = gql`
    query getStudentFeeDashboardDetails($institute_id: Int, $branch_ids: [Int], $academic_year_id: Int) {
        getStudentFeeDashboardDetails(institute_id: $institute_id, branch_ids: $branch_ids, academic_year_id: $academic_year_id) {
            student_id
roll_no
admission_no
student_name
contact_no
dob
father_name
father_phone
mother_name
mother_phone
branch_id
branch_name
class_id
class_name
section_id
section_name
total_amount
discount
paid_amount
internal_amount
pending_amount
overdue_amount
        }
    }
`;

// Show "-" for null/undefined/empty cells. Keeps 0 (valid amount) as-is.
const dash = (cell) => (cell === null || cell === undefined || cell === "") ? "-" : cell;

class StudentPayments extends Component {
    constructor(props) {
        super(props)
        this.state = {
            yearSearch: "",
            branchSearch: [],
            classSearch: [],
            streamSearch: [],
            sectionSearch: [],

            branches: [],
            getClasses: [],
            allStreams: [],

            dashboardStudents: [],
            dashboardLoading: false,
            didInitialFetch: false,
            deductOthers: false,

            loadingSpinner: 0,
            feeModal: false,
            studentPaymentData: [],
            totalAmount: 0,
            studentMobile: "",
            student_id: null,
            tutionFee: 0,
            individualDetails: [],
            student_name: "",
            parent_name: "",
            exam_name: "",
            class_name: "",
            section_name: "",
            roll_no: "",
            admission_no: "",
            row_branch_id: 0,
            academic_year_text: "",
            feeReportDateWiseModal: false,
            accessDeniedShow: false
        }

        this.guard = attachModuleGuard(this, FEE_STRUCTURE_MODULE);
    };

    componentDidMount() {
        this.getBranches();
        this.getClasses();
        this.getStreamsList();
        // Branch comes from the header (NavbarOne) — reload the scoped branch set
        // (and the cascading class/stream/section defaults) whenever it changes.
        this.offBranchScope = onBranchScopeChange(() => this.getBranches());
    }

    componentWillUnmount() {
        if (this.offBranchScope) this.offBranchScope();
    }

    // ── Stream helpers: stream only narrows the section list (sections carry stream_id) ──
    // `allBranches` is passed in rather than read from state: getBranches() calls these
    // helpers BEFORE its setState, when this.state.branches is still empty. Judged across
    // every branch, not just the selected one, so a class doesn't flip between
    // streamed/unstreamed depending on which branch happens to be picked.
    isStreamClassIn = (allBranches, classId) =>
        (allBranches || [])
            .flatMap(b => b.sections || [])
            .some(s => Number(s.class_id) === Number(classId) && Number(s.stream_id) > 0);

    isStreamClass = (classId) => this.isStreamClassIn(this.state.branches, classId);

    streamIdsFor = (branchObjs, classIds, allBranches = this.state.branches) =>
        [...new Set(
            branchObjs.flatMap(b => b.sections || [])
                .filter(s => classIds.map(Number).includes(Number(s.class_id))
                    && this.isStreamClassIn(allBranches, s.class_id) && s.stream_id)
                .map(s => Number(s.stream_id))
        )];

    // Stream narrowing must never empty the list: it applies only to a streamed class,
    // only once a stream is actually picked, and never hides a section that carries no
    // stream_id (Class 11/12 have ~244 such rows — they must stay visible, as before).
    matchesStreamIn = (allBranches, s, streamIds) =>
        !this.isStreamClassIn(allBranches, s.class_id)
        || streamIds.length === 0
        || !(Number(s.stream_id) > 0)
        || streamIds.map(Number).includes(Number(s.stream_id));

    matchesStream = (s, streamIds) => this.matchesStreamIn(this.state.branches, s, streamIds);

    sectionIdsFor = (branchObjs, classIds, streamIds, allBranches = this.state.branches) =>
        branchObjs.flatMap(b => b.sections || [])
            .filter(s => classIds.map(Number).includes(Number(s.class_id)))
            .filter(s => this.matchesStreamIn(allBranches, s, streamIds))
            .map(s => s.id);

    componentDidUpdate(prevProps, prevState) {
        const academicYears = this.props.getAcademicYearsQuery?.getAcademicYears || [];
        if (academicYears.length > 0 && !this.state.yearSearch) {
            const now = new Date();
            const startYear = now.getMonth() >= 4 ? now.getFullYear() : now.getFullYear() - 1;
            const shortStr = `${startYear}-${String(startYear + 1).slice(-2)}`;
            const longStr = `${startYear}-${startYear + 1}`;
            const defaultYear = academicYears.find(y => y.academic_year === shortStr)
                || academicYears.find(y => y.academic_year === longStr)
                || academicYears[0];
            this.setState({
                yearSearch: defaultYear.id,
                academic_year_text: defaultYear.academic_year,
            }, () => {
                if (this.state.branchSearch.length > 0) this.fetchDashboard();
            });
        }
        // Guaranteed one-time auto-load: as soon as both the year and branches are ready
        // (in whichever order the two async sources resolve), fetch the dashboard once.
        if (this.state.yearSearch && this.state.branchSearch.length > 0 && !this.state.didInitialFetch) {
            this.setState({ didInitialFetch: true }, () => this.fetchDashboard());
            return;
        }

        if (
            this.state.yearSearch && this.state.branchSearch.length > 0 &&
            (prevState.yearSearch !== this.state.yearSearch || prevState.branchSearch.length !== this.state.branchSearch.length)
        ) {
            this.fetchDashboard();
        }
    }

    getBranches = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_BRANCHES,
                variables: { institution_id: parseInt(Cookies.get("institutionid")) },
                fetchPolicy: "network-only",
            });
            // The header's branch selection IS the branch filter for this page.
            const branches = scopeBranches(result.data.getBranches || []);
            const allBranchIds = branches.map(b => b.id);
            const allClassIds = Array.from(new Set(branches.flatMap(b => b.sections || []).map(s => s.class_id)));
            // Pass `branches` as allBranches too: state.branches isn't set until below.
            const allStreamIds = this.streamIdsFor(branches, allClassIds, branches);
            const allSectionIds = this.sectionIdsFor(branches, allClassIds, allStreamIds, branches);
            this.setState(
                { branches, branchSearch: allBranchIds, classSearch: allClassIds, streamSearch: allStreamIds, sectionSearch: allSectionIds },
                () => { if (this.state.yearSearch) this.fetchDashboard(); }
            );
        } catch {
            // ignore
        }
    };

    getClasses = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_CLASSES,
                variables: { id: 1 },
                fetchPolicy: "network-only",
            });
            this.setState({ getClasses: result.data.getExamClasses || [] });
        } catch {
            // ignore
        }
    };

    getStreamsList = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_STREAMS,
                fetchPolicy: "network-only",
            });
            this.setState({ allStreams: result.data.getStreams || [] });
        } catch {
            // ignore
        }
    };

    fetchDashboard = async () => {
        const { yearSearch, branchSearch } = this.state;
        if (!yearSearch || branchSearch.length === 0) return;
        this.setState({ dashboardLoading: true });
        try {
            const result = await this.props.client.query({
                query: GET_STUDENT_FEE_DASHBOARD,
                variables: {
                    institute_id: parseInt(Cookies.get("institutionid")),
                    branch_ids: branchSearch.map(Number),
                    academic_year_id: parseInt(yearSearch),
                },
                fetchPolicy: "network-only",
            });
            this.setState({
                dashboardStudents: result.data.getStudentFeeDashboardDetails || [],
                dashboardLoading: false,
            });
        } catch {
            this.setState({ dashboardLoading: false });
        }
    };

    tableData(students) {
        const deduct = this.state.deductOthers;
        return students.map((s) => {
            const others = parseInt(s.internal_amount) || 0;
            // When "deduct others" is on, subtract Others from Paid (Total stays as-is) and show the
            // Others value. When unchecked, Others shows 0 and Paid is the full amount.
            const totalAmount = s.total_amount;
            const paidAmount  = deduct ? (parseInt(s.paid_amount) || 0) - others : s.paid_amount;
            const othersShown = deduct ? others : 0;
            return {
            id: s.student_id,
            student_id: s.student_id,
            student_name: s.student_name,
            parent_name: s.parent_name || s.father_name || "",
            roll_no: s.roll_no,
            admission_no: s.admission_no,
            contact_no: s.contact_no,
            dob: s.dob || "",
            father_name: s.father_name || "",
            father_phone: s.father_phone || "",
            mother_name: s.mother_name || "",
            mother_phone: s.mother_phone || "",
            branch_name: s.branch_name,
            class_name: s.class_name,
            section_name: s.section_name,
            total_amount: totalAmount,
            discount: s.discount,
            paid_amount: paidAmount,
            internal_amount: othersShown,
            pending_amount: s.pending_amount,
            branch: s.branch_id,
            class_id: s.class_id,
            section_id: s.section_id,
            student_mobile: s.contact_no,
            term_details: [],
            tutionFee: 0,
            individualDetails: [],
            exam_name: "",
            };
        });
    };

    articlecolumns = [
        { dataField: "sno", text: "#", formatter: (cell, row, rowIndex) => rowIndex + 1, classes: "fee-sticky-l1", headerClasses: "fee-sticky-l1" },
        { dataField: "student_name", text: "Student Name", sort: true, formatter: dash, classes: "fee-sticky-l2", headerClasses: "fee-sticky-l2" },
        { dataField: "roll_no", text: "Roll No", sort: true, formatter: dash },
        { dataField: "admission_no", text: "Admission No", sort: true, formatter: dash },
        // { dataField: "contact_no", text: "Contact No", sort: true, formatter: dash },
        // { dataField: "dob", text: "Date of Birth", sort: true, formatter: dash },
        { dataField: "father_name", text: "Father Name", sort: true, formatter: dash },
        // { dataField: "father_phone", text: "Father Phone", sort: true, formatter: dash },
        // { dataField: "mother_name", text: "Mother Name", sort: true, formatter: dash },
        // { dataField: "mother_phone", text: "Mother Phone", sort: true, formatter: dash },
        { dataField: "branch_name", text: "Branch", sort: true, formatter: dash },
        { dataField: "class_name", text: "Class", sort: true, formatter: dash },
        { dataField: "section_name", text: "Section", sort: true, formatter: dash },
        { dataField: "total_amount", text: "Total Amount", formatter: dash },
        { dataField: "discount", text: "Discount", formatter: dash },
        { dataField: "paid_amount", text: "Paid Amount", formatter: dash },
        { dataField: "internal_amount", text: "Term Fee", formatter: dash },
        { dataField: "pending_amount", text: "Pending Amount", formatter: dash },
        { dataField: "Fee Status", formatter: this.performanceFunc.bind(this), text: "Fee Update", classes: "fee-sticky-r2", headerClasses: "fee-sticky-r2" },
        { dataField: "Fee Report", formatter: this.reportPerformanceFunc.bind(this), text: "Fee Report", classes: "fee-sticky-r1", headerClasses: "fee-sticky-r1" },
    ];

    // Opens FeeStatusModal — the collect-payment / apply-concession / configure-terms
    // editor. This is the ONLY way in, so gating here stops every write in that modal.
    // The row's edit icon stays visible and clickable.
    showFeeModal = (studentData, total_amount, mobile, tutionFee, individualDetails, student_name, exam_name, class_name, section_name, roll_no, branch_id, student_id, parent_name, admission_no) => {
        if (!this.guard.requireEdit()) return;

        this.setState({
            feeModal: true,
            studentPaymentData: studentData,
            totalAmount: total_amount,
            studentMobile: mobile,
            student_id: student_id,
            tutionFee: tutionFee,
            individualDetails: individualDetails,
            student_name: student_name,
            parent_name: parent_name || "",
            exam_name: exam_name,
            class_name: class_name,
            section_name: section_name || "",
            roll_no: roll_no,
            admission_no: admission_no || "",
            row_branch_id: branch_id
        });
    };

    performanceFunc(cell, row, rowIndex, formatExtraData) {
        return (
            <div className="actions-buttons d-flex justify-content-center align-items-top"
                onClick={() => this.showFeeModal(row.term_details, row.total_amount, row.student_mobile, row.tutionFee, row.individualDetails, row.student_name, row.exam_name, row.class_name, row.section_name, row.roll_no, row.branch, row.student_id, row.parent_name, row.admission_no)}>
                <Button variant="link" name="edit" className="text-theme" style={{ cursor: "pointer" }}>
                    <i className="far fa-edit" />
                </Button>
            </div>
        );
    };

    reportPerformanceFunc(cell, row, rowIndex, formatExtraData) {
        return (
            <div className="actions-buttons d-flex justify-content-center align-items-top">
                <Button variant="link" name="edit" className="text-theme" style={{ cursor: "pointer" }}
                    onClick={() => this.showDateWiseFeeModal(row.term_details, row.student_name, row.exam_name, row.class_name, row.individualDetails, row.roll_no, row.branch, row.student_id, row.admission_no)}>
                    Report
                </Button>
            </div>
        );
    }

    showDateWiseFeeModal = (term_details, student_name, exam_name, class_name, individualDetails, roll_no, branch_id, student_id, admission_no) => {
        this.setState({
            studentPaymentData: term_details,
            student_name: student_name,
            exam_name: exam_name,
            class_name: class_name,
            individualDetails: individualDetails,
            roll_no: roll_no,
            admission_no: admission_no || "",
            row_branch_id: branch_id,
            student_id: student_id,
            feeReportDateWiseModal: true
        });
    }

    render() {
        const getOrganisationProfile = this.props.getOrganisationProfile;
        const loading3 = getOrganisationProfile.loading;
        const error3 = getOrganisationProfile.error;

        if (error3 !== undefined) {
            alert("Server Error. " + error3.message);
            return null;
        }

        if (loading3) return null;

        const academicYears = this.props.getAcademicYearsQuery?.getAcademicYears || [];

        const { yearSearch, branchSearch, classSearch, streamSearch, sectionSearch, branches, getClasses, allStreams } = this.state;

        // No branch selected → no classes/sections to choose from (cascade resets downward)
        const selectedBranchObjs = branchSearch.length > 0
            ? branches.filter(b => branchSearch.map(Number).includes(Number(b.id)))
            : [];

        const branchClassIds = new Set(selectedBranchObjs.flatMap(b => (b.sections || []).map(s => Number(s.class_id))));
        const classOptions = branchSearch.length === 0
            ? []
            : getClasses
                .filter(c => branchClassIds.has(Number(c.id)))
                .map(c => ({ value: c.id, label: c.class }));

        // Stream options — only the streams that exist among the selected stream-classes' sections
        const streamOptions = (branchSearch.length === 0 || classSearch.length === 0)
            ? []
            : this.streamIdsFor(selectedBranchObjs, classSearch)
                .map(sid => {
                    const st = allStreams.find(s => Number(s.id) === Number(sid));
                    return st ? { value: sid, label: st.stream } : null;
                })
                .filter(Boolean);
        const showStream = streamOptions.length > 0;

        // Sections arrive ordered by class_id, which puts Nursery (id 15) after Class 10.
        // Order by the class master instead — getExamClasses comes back in order_no order,
        // so a class's index in it is its academic rank (Nursery, LKG, UKG, Class 1 …).
        // That matches the Class dropdown above and lifts Nursery to the top.
        const classRank = (classId) => {
            const i = getClasses.findIndex(c => Number(c.id) === Number(classId));
            return i === -1 ? Number.MAX_SAFE_INTEGER : i;   // unknown class → last, never dropped
        };

        // No class selected → no sections to choose from. Stream-class sections are further narrowed by stream.
        const sectionOptions = (branchSearch.length === 0 || classSearch.length === 0)
            ? []
            : selectedBranchObjs
                .flatMap(b => b.sections || [])
                .filter(s => classSearch.map(Number).includes(Number(s.class_id)))
                .filter(s => this.matchesStream(s, streamSearch))
                .sort((a, b) => classRank(a.class_id) - classRank(b.class_id)
                    || String(a.section_name || '').localeCompare(String(b.section_name || '')))
                .map(s => ({ value: s.id, label: s.section_name }));

        let StudentsFilterData = [];

        if (branchSearch.length > 0 && classSearch.length > 0 && sectionSearch.length > 0) {
            StudentsFilterData = this.state.dashboardStudents
                .filter(a => branchSearch.map(Number).includes(Number(a.branch_id)))
                .filter(a => classSearch.map(Number).includes(Number(a.class_id)))
                .filter(a => sectionSearch.map(Number).includes(Number(a.section_id)));
        }

        const S = {
            page: { padding: "8px 0" },
            card: { background: "#fff", borderRadius: 20, boxShadow: "0 2px 16px rgba(0,0,0,0.07)", marginBottom: 24, overflow: "hidden" },
            cardHeader: {
                background: "#ffffff",
                padding: "20px 24px",
                display: "flex",
                alignItems: "center",
                gap: 14,
                borderBottom: "1px solid #f1f5f9",
            },
            iconWrapperList: {
                width: 38,
                height: 38,
                borderRadius: 10,
                background: "#f5f3ff",
                border: "1px solid #ddd6fe",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#7c3aed",
                fontSize: 16,
                flexShrink: 0,
            },
            cardTitleText: {
                display: "flex",
                flexDirection: "column",
                textAlign: "left",
            },
            cardTitle: {
                color: "#0f172a",
                fontWeight: 700,
                fontSize: 16,
                margin: 0,
                letterSpacing: "-0.01em",
            },
            cardSubtitle: {
                color: "#64748b",
                fontSize: 12,
                fontWeight: 500,
                marginTop: 2,
            },
            countChip: {
                background: "#f5f3ff",
                color: "#7c3aed",
                borderRadius: 20,
                padding: "4px 12px",
                fontWeight: 600,
                fontSize: 12,
                border: "1px solid #ddd6fe",
                marginLeft: "auto",
            },
            input: { borderRadius: 10, border: "1.5px solid #e5e7eb", padding: "9px 14px", fontSize: 14, color: "#1f2937", background: "#f9fafb", width: "100%" },
        };

        return (
            <div style={S.page}>
                <div style={S.card}>
                    <div style={S.cardHeader}>
                        <div style={S.iconWrapperList}>
                            <i className="fal fa-wallet" />
                        </div>
                        <div style={S.cardTitleText}>
                            <h5 style={S.cardTitle}>Payments</h5>
                            <span style={S.cardSubtitle}>Manage student fee payments and transactions</span>
                        </div>
                        <span style={S.countChip}>{StudentsFilterData.length} students</span>
                    </div>

                    <div style={{ padding: "16px 24px", borderBottom: "1px solid #f3f4f6" }}>
                        <Row className="g-2">
                            <Col md={3}>
                                <label style={{ fontSize: 12, fontWeight: 600, color: "#6b7280", marginBottom: 4, display: "block" }}>Academic Year</label>
                                <select
                                    value={yearSearch}
                                    onChange={(e) => {
                                        const selectedYear = academicYears.find(y => y.id == e.target.value);
                                        this.setState({ yearSearch: e.target.value, academic_year_text: selectedYear?.academic_year || "" });
                                    }}
                                    style={S.input}
                                >
                                    {academicYears.map((y) => (
                                        <option key={y.id} value={y.id}>{y.academic_year}</option>
                                    ))}
                                </select>
                            </Col>

                            {/* No Branch filter — the header's branch selection scopes this page. */}

                            <Col md={3}>
                                <label style={{ fontSize: 12, fontWeight: 600, color: "#6b7280", marginBottom: 4, display: "block" }}>Class</label>
                                <CheckboxDropdown
                                    options={classOptions}
                                    value={classSearch}
                                    onChange={(val) => {
                                        if (val.length === 0) {
                                            this.setState({ classSearch: [], streamSearch: [], sectionSearch: [] });
                                            return;
                                        }
                                        const selBranches = branchSearch.length > 0 ? branches.filter(b => branchSearch.map(Number).includes(Number(b.id))) : branches;
                                        const newStreamIds = this.streamIdsFor(selBranches, val);
                                        const newSectionIds = this.sectionIdsFor(selBranches, val, newStreamIds);
                                        this.setState({ classSearch: val, streamSearch: newStreamIds, sectionSearch: newSectionIds });
                                    }}
                                    placeholder="Select Class"
                                />
                            </Col>

                            {showStream && (
                                <Col md={3}>
                                    <label style={{ fontSize: 12, fontWeight: 600, color: "#6b7280", marginBottom: 4, display: "block" }}>Stream</label>
                                    <CheckboxDropdown
                                        options={streamOptions}
                                        value={streamSearch}
                                        onChange={(val) => {
                                            const selBranches = branchSearch.length > 0 ? branches.filter(b => branchSearch.map(Number).includes(Number(b.id))) : branches;
                                            const newSectionIds = this.sectionIdsFor(selBranches, classSearch, val);
                                            this.setState({ streamSearch: val, sectionSearch: newSectionIds });
                                        }}
                                        placeholder="Select Stream"
                                    />
                                </Col>
                            )}

                            <Col md={3}>
                                <label style={{ fontSize: 12, fontWeight: 600, color: "#6b7280", marginBottom: 4, display: "block" }}>Section</label>
                                <CheckboxDropdown
                                    options={sectionOptions}
                                    value={sectionSearch}
                                    onChange={(val) => this.setState({ sectionSearch: val })}
                                    placeholder="Select Section"
                                />
                            </Col>
                        </Row>
                    </div>

                    <div style={{ padding: "16px 24px" }}>
                        <div style={{ marginBottom: 12 }}>
                            <label style={{ display: "inline-flex", alignItems: "center", gap: 8, cursor: "pointer", fontSize: 13, color: "#374151", fontWeight: 600 }}>
                                <input
                                    type="checkbox"
                                    checked={this.state.deductOthers}
                                    onChange={(e) => this.setState({ deductOthers: e.target.checked })}
                                    style={{ width: 16, height: 16, accentColor: "#6366f1" }}
                                />
                                Deduct Term Fee (show Paid amount minus Term Fee)
                            </label>
                        </div>
                        {this.state.dashboardLoading ? (
                            <>
                                <style>{`
                                    @keyframes shimmer {
                                        0%   { background-position: -800px 0; }
                                        100% { background-position:  800px 0; }
                                    }
                                    .sp-shimmer {
                                        background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
                                        background-size: 800px 100%;
                                        animation: shimmer 1.4s infinite linear;
                                        border-radius: 5px;
                                    }
                                `}</style>
                                {/* shimmer search bar */}
                                <div style={{ marginBottom: 14 }}>
                                    <div className="sp-shimmer" style={{ height: 34, width: 220, borderRadius: 8 }} />
                                </div>
                                {/* shimmer header */}
                                <div style={{ display: "flex", gap: 10, padding: "10px 0", borderBottom: "2px solid #f3f4f6", marginBottom: 4 }}>
                                    {[60, 120, 90, 80, 60, 70, 80, 70, 80, 90, 70, 70].map((w, i) => (
                                        <div key={i} className="sp-shimmer" style={{ height: 13, width: w, flexShrink: 0 }} />
                                    ))}
                                </div>
                                {/* shimmer rows */}
                                {[1, 2, 3, 4, 5, 6, 7].map(row => (
                                    <div key={row} style={{ display: "flex", gap: 10, padding: "13px 0", borderBottom: "1px solid #f3f4f6", alignItems: "center" }}>
                                        {[60, 120, 90, 80, 60, 70, 80, 70, 80, 90, 30, 40].map((w, i) => (
                                            <div key={i} className="sp-shimmer" style={{ height: 12, width: w, flexShrink: 0 }} />
                                        ))}
                                    </div>
                                ))}
                            </>
                        ) : (
                            <CardLessDataTable
                                parentData={this.tableData(StudentsFilterData)}
                                particlecolumns={this.articlecolumns}
                                search={true}
                                name="hostel_attendance"
                            />
                        )}
                    </div>
                </div>

                <FeeStatusModal
                    show={this.state.feeModal}
                    onHide={() => this.setState({ feeModal: false })}
                    onRefresh={this.fetchDashboard}
                    studentPaymentData={this.state.studentPaymentData}
                    globals={this.props.globals}
                    totalAmount={this.state.totalAmount}
                    studentMobile={this.state.studentMobile}
                    tutionFee={this.state.tutionFee}
                    individualDetails={this.state.individualDetails}
                    getPaymentModes={this.props.getPaymentModes}
                    studentName={this.state.student_name}
                    examName={this.state.exam_name}
                    getOrganisationProfile={this.props.getOrganisationProfile.getOrganisationProfile}
                    stateData={this.state}
                />

                <FeeReportDateWise
                    show={this.state.feeReportDateWiseModal}
                    onHide={() => this.setState({ feeReportDateWiseModal: false })}
                    studentPaymentData={this.state.studentPaymentData}
                    studentName={this.state.student_name}
                    examName={this.state.exam_name}
                    class_name={this.state.class_name}
                    getPaymentModes={this.props.getPaymentModes}
                    roll_no={this.state.roll_no}
                    admission_no={this.state.admission_no}
                    getOrganisationProfile={this.props.getOrganisationProfile.getOrganisationProfile}
                    globals={this.props.globals}
                    stateData={this.state}
                />

                {/* Shown instead of opening the payment/concession editor when is_edit is
                    missing. This tab has no delete surface. */}
                <AccessDeniedModal
                    show={this.state.accessDeniedShow}
                    onHide={this.guard.hideAccessDenied}
                />
            </div>
        )
    }
}

export default withRouter(
    withApollo(
        compose(
            graphql(
                gql`
          query ($institution_id: Int!) {
            getOrganisationProfile(institution_id: $institution_id) {
              id
              organisation_name
              chairman
              contact_no
              complete_address
              region_id
              logo
              hod
              hod_mobile
              principal
              principal_mobile
              vice_principal
              vice_principal_mobile
              timestamp
              branch_wise_data {
                branch_id
                branch_name
                branch_wise_address
              }
            }
          }
        `,
                {
                    name: "getOrganisationProfile",
                    options: props => ({
                        variables: {
                            institution_id: parseInt(Cookies.get("institutionid"))
                        },
                    })
                }
            ),

            graphql(GET_ACADEMIC_YEARS, {
                name: "getAcademicYearsQuery",
                options: {
                    variables: { id: 1 },
                },
                fetchPolicy: "network-only"
            })

        )(StudentPayments)
    )
);
